import { createBrowserRouter, Navigate, redirect } from 'react-router-dom';

import { AuthLayout } from './components/layouts/AuthLayout';
import { DashboardLayout } from './components/layouts/DashboardLayout';
// Layouts
import { RootLayout } from './components/layouts/RootLayout';
// Authentication related utilities
import { isAuthenticated } from './lib/auth';
import { Dashboard } from './pages/Dashboard';
// Pages
import { Login } from './pages/Login';
import { Logs } from './pages/Logs';
import { Monitoring } from './pages/Monitoring';
import { NotFound } from './pages/NotFound';
import { PlayerDetail } from './pages/PlayerDetail';
import { Players } from './pages/Players';
import { ProgramBatchCreate } from './pages/ProgramBatchCreate';
import { ProgramDetail } from './pages/ProgramDetail';
import { Programs } from './pages/Programs';

// Loader for routes that require authentication
const authLoader = () => {
  if (!isAuthenticated()) {
    return redirect('/login');
  }
  return null;
};

// Redirect for authenticated users (e.g., login page)
const redirectIfAuthenticated = () => {
  if (isAuthenticated()) {
    return redirect('/');
  }
  return null;
};

// Route definitions
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      // Routes that require authentication
      {
        element: <AuthLayout />,
        loader: authLoader,
        children: [
          {
            element: <DashboardLayout />,
            children: [
              {
                index: true,
                element: <Dashboard />,
              },
              {
                path: 'programs',
                children: [
                  {
                    index: true,
                    element: <Programs />,
                  },
                  {
                    path: 'new',
                    element: <ProgramDetail />,
                  },
                  {
                    path: 'edit',
                    element: <ProgramDetail />,
                  },
                  {
                    path: 'batch',
                    element: <ProgramBatchCreate />,
                  },
                ],
              },
              {
                path: 'players',
                children: [
                  {
                    index: true,
                    element: <Players />,
                  },
                  {
                    path: 'new',
                    element: <PlayerDetail />,
                  },
                  {
                    path: 'edit',
                    element: <PlayerDetail />,
                  },
                ],
              },
              {
                path: 'monitoring',
                children: [
                  {
                    index: true,
                    element: <Monitoring />,
                  },
                ],
              },
              {
                path: 'logs',
                children: [
                  {
                    index: true,
                    element: <Logs />,
                  },
                ],
              },
            ],
          },
        ],
      },
      // Routes that don't require authentication
      {
        path: 'login',
        element: <Login />,
        loader: redirectIfAuthenticated,
      },
      // Redirect to root path
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);
